import { random } from 'lodash-es';

export interface Auth0AppState {
  /** The key in local storage that stores a redirect URL. */
  returnToKey?: string;
}

const RETURN_TO_KEY_PREFIX = 'ocula-return-to-';

/**
 * Stores a redirect url in local storage using a random number as a key
 *
 * @returns The key the redirect url was stored with, as an object to
 * be used as the value of the `appState` parameter for Auth0.
 */
export function storeRedirectUrl(url?: string | null): Auth0AppState {
  const returnToKey = `${RETURN_TO_KEY_PREFIX}${random(Number.MAX_SAFE_INTEGER)}`;
  globalThis.localStorage.setItem(returnToKey, url ?? '/');
  return { returnToKey };
}

/**
 * Retrieves the redirect url that was stored using `storeRedirectUrl`.
 * Also removes the stored value.
 *
 * @param appState The appState object originally passed to Auth0.
 * @returns The redirect url if it could be found, else `null`.
 */
// biome-ignore lint/suspicious/noExplicitAny: TODO: fix
export function retrieveRedirectUrl(appState: any) {
  const returnToKey = appState ? (appState as Auth0AppState).returnToKey : null;
  if (!returnToKey) {
    return null;
  }
  const redirectUrl = globalThis.localStorage.getItem(returnToKey);
  // Clean up any and all keys in local storage that start with the key prefix.
  // This is because the key would otherwise be left permanently in local storage
  // if the user does not complete the login process for some reason.
  // biome-ignore lint/complexity/noForEach: TODO: fix
  Object.keys(globalThis.localStorage)
    .filter((x) => x.startsWith(RETURN_TO_KEY_PREFIX))
    .forEach((key) => localStorage.removeItem(key));
  return redirectUrl;
}
